import { ModelEntityType } from '../../../input/types';
import { CompanyKeyTakeaway } from './company/types-company-key-takeaway';
import { WeightSetKeyTakeaway } from './weight-set/types-weight-set-key-takeaway';

export enum KeyTakeawayType {
  BIGGEST_POSITIVE = 'pos',
  BIGGEST_NEGATIVE = 'neg',
  BEST_VALUE_SET = 'value',
  HOW_TO_IMPROVE = 'improve',
}

export interface KeyTakeawayCommon {
  resultId?: string;
  entityType: ModelEntityType;
}

export type KeyTakeaway = CompanyKeyTakeaway | WeightSetKeyTakeaway;

// For placeholder tags in generated strings.
// NOTE: Spaces and special characters in enum values
// will break stuff.
export enum KTTag {
  Entity = 'Entity',
  IMPACT = 'Impact',
  PRODUCT = 'Product',
  VALUE_SET = 'ValueSet',
}

export enum KTAttr {
  ID = 'id',
}
